import { defineStore } from "pinia"

export const useAnnotationStore = defineStore("annotation", {
  state: () => ({
    isGlobal: false, // used in GlobalAnnotationButton to determine if the annotation started globaly
    annotationMode: false,
    isDrawing: false,
    isErasing: false,
    drawColor: "#f9d805",
    lineWidth: 5,
    colorPickerOpen: false,
    sizeSliderOpen: false,
    isDragging: false,
    isDrawingFilledRectangle: false,
    isDrawingInverseFilledRectangle: false,
  }),

  actions: {
    setIsDragging(value: boolean) {
      this.isDragging = value
    },

    toggleAnnotationMode() {
      this.annotationMode = !this.annotationMode
      if (!this.annotationMode) {
        this.isGlobal = false
        this.isErasing = false
        this.isDrawingFilledRectangle = false
        this.isDrawingInverseFilledRectangle = false
        this.colorPickerOpen = false
        this.sizeSliderOpen = false
      }
    },

    toggleColorPicker() {
      this.colorPickerOpen = !this.colorPickerOpen
      this.sizeSliderOpen = false
    },

    toggleSizeSlider() {
      this.sizeSliderOpen = !this.sizeSliderOpen
      this.colorPickerOpen = false
    },

    toggleEraser() {
      this.isErasing = !this.isErasing
      if (this.isErasing) {
        this.isDrawingFilledRectangle = false
        this.isDrawingInverseFilledRectangle = false
      }
      this.colorPickerOpen = false
      this.sizeSliderOpen = false
    },

    toggleRectangleTool() {
      this.isDrawingFilledRectangle = !this.isDrawingFilledRectangle
      if (this.isDrawingFilledRectangle) {
        this.isErasing = false
        this.isDrawingInverseFilledRectangle = false
      }
      this.colorPickerOpen = false
      this.sizeSliderOpen = false
    },

    toggleInverseRectangleTool() {
      this.isDrawingInverseFilledRectangle = !this.isDrawingInverseFilledRectangle
      if (this.isDrawingInverseFilledRectangle) {
        this.isErasing = false
        this.isDrawingFilledRectangle = false
      }
      this.colorPickerOpen = false
      this.sizeSliderOpen = false
    },

    setIsDrawing(value: boolean) {
      this.isDrawing = value
    },

    resetAnnotation() {
      this.annotationMode = false
      this.isGlobal = false
      this.isDrawing = false
      this.isErasing = false
      this.isDrawingFilledRectangle = false
      this.isDrawingInverseFilledRectangle = false
      this.drawColor = "#f9d805"
      this.lineWidth = 5
      this.isDragging = false
      this.colorPickerOpen = false
      this.sizeSliderOpen = false
    },
  },
})
